// Monospace treatment for machine identifiers (registry codes, entry keys, JSON
// paths, bound values). One shared constant so every screen uses the same face.
export const MONO_FONT = 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';
